import React from "react";

import { HubDialogWrapper } from "../HubDialogWrapper";
import CreateCustomerPartContent from "./CreateCustomerPartContent";

export const CreateCustomerPartDialog = () => {
  const name = "create-customer-part";

  return (
    <HubDialogWrapper maxWidth="sm" name={name}>
      <CreateCustomerPartContent />
    </HubDialogWrapper>
  );
};

export default CreateCustomerPartDialog;
